import { render, staticRenderFns } from "./tabelaFrete.vue?vue&type=template&id=681c1994"
import script from "./tabelaFrete.vue?vue&type=script&lang=js"
export * from "./tabelaFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports